import { all } from 'redux-saga/effects';
import Auth from './Auth';
import FetchedData from './fetchedData';

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    FetchedData(),
  ]);
}
